import type { Site } from "./api";

export type SiteDisplayState =
  | "no-build"
  | "building"
  | "draft"
  | "active"
  | "needs-attention";

export type SiteLifecycleInput = Pick<
  Site,
  "status" | "pendingBuildId" | "previewBuildId" | "liveBuildId"
>;

/**
 * pendingBuildId is the only trustworthy signal that work is in flight.
 * Status is persisted display metadata and may lag after crashes or legacy
 * editor preparation, so a usable preview always wins over stale "building".
 */
export function siteDisplayState(site: SiteLifecycleInput): SiteDisplayState {
  if (site.pendingBuildId) return "building";
  if (site.status === "active" && site.liveBuildId) return "active";
  if (site.previewBuildId) return "draft";
  if (["ready_unverified", "retry", "failed", "timeout", "cancelled"].includes(site.status)) {
    return "needs-attention";
  }
  return "no-build";
}

export const isSiteBuilding = (site: SiteLifecycleInput): boolean =>
  siteDisplayState(site) === "building";
